import { Tablist } from 'evergreen-ui'

type Props = {
  border?: 'left' | 'right'
  children: JSX.Element | JSX.Element[]
  isHiddenMobile?: boolean
  isHiddenDesktop?: boolean
}

export default function ToolGroup(props: Props) {
  let className = 'tool-group'
  if (props.border) {
    className += ` divider divider-${props.border}`
  }
  if (props.isHiddenMobile) {
    className += ' is-hidden-mobile'
  }
  if (props.isHiddenDesktop) {
    className += ' is-hidden-desktop'
  }
  return (
    <Tablist
      alignItems="center"
      className={className}
      display="flex"
      flexGrow={1}
      justifyContent="flex-start"
      minHeight={40}
      whiteSpace="nowrap"
    >
      {props.children}
    </Tablist>
  )
}
